import Layout from "@/page/index/";

export default [
  {
    path: "/wel",
    component: Layout,
    redirect: "/wel/index",
    children: [
      {
        path: "index",
        name: "首页",
        meta: {
          i18n: "dashboard",
        },
        //   component: () =>
        //     import( /* webpackChunkName: "views" */ '@/views/wel/index')
        // },
        component: (resolve) => require(["@/views/wel/index"], resolve),
      },
      {
        path: "dashboard",
        name: "控制台",
        meta: {
          i18n: "dashboard",
          menu: false,
        },
        // component: () =>
        //   import( /* webpackChunkName: "views" */ '@/views/wel/dashboard')
        component: (resolve) => require(["@/views/wel/dashboard"], resolve),
      },
    ],
  },
  {
    path: "/test",
    component: Layout,
    redirect: "/test/index",
    children: [
      {
        path: "index",
        name: "测试页",
        meta: {
          i18n: "test",
        },
        // component: () =>
        //   import( /* webpackChunkName: "views" */ '@/views/util/test')
        component: (resolve) => require(["@/views/util/test"], resolve),
      },
    ],
  },
  {
    path: "/info",
    component: Layout,
    redirect: "/info/index",
    children: [
      {
        path: "index",
        name: "个人信息",
        meta: {
          i18n: "info",
        },
        // component: () =>
        //   import( /* webpackChunkName: "views" */ '@/views/user/info')
        component: (resolve) => require(["@/views/user/info"], resolve),
      },
    ],
  },
  {
    path: "/storeExecutionForm",
    component: Layout,
    meta: {
      menu: false,
    },
    children: [
      {
        path: "add",
        name: "新增规则",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/storeExecution/ruleForm"], resolve),
      },
      {
        path: "edit/:id",
        name: "编辑规则",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/storeExecution/ruleForm"], resolve),
      },
      {
        path: "view/:id",
        name: "查看规则",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/storeExecution/ruleForm"], resolve),
      },
    ],
  },
  {
    path: "/visitManagement",
    component: Layout,
    meta: {
      menu: false,
    },
    children: [
      {
        path: "visitRule",
        name: "访店规则管理",
        meta: {
          menu: false,
          title: "访店规则管理",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/visitRule"], resolve),
      },
      {
        path: "visitPlan",
        name: "拜访计划管理",
        meta: {
          menu: false,
          title: "拜访计划管理",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/visitPlan"], resolve),
      },
      {
        path: "statisticalRules",
        name: "统计规则管理",
        meta: {
          menu: false,
          title: "统计规则管理",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/statisticalRules"], resolve),
      },
      {
        path: "statisticalRulesDetail/:mode/:id",
        name: "统计规则详情",
        meta: {
          menu: false,
          title: "统计规则详情",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/statisticalRulesDetail"], resolve),
      },
      {
        path: "visitRuleDetail/:id",
        name: "拜访规则详情",
        meta: {
          menu: false,
          title: "拜访规则详情",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/visitRuleDetail"], resolve),
      },
      {
        path: "checkInRule",
        name: "打卡规则管理",
        meta: {
          menu: false,
          title: "打卡规则管理",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/checkInRule"], resolve),
      },
      {
        path: "checkInRuleForm/add",
        name: "新增打卡规则",
        meta: {
          menu: false,
          title: "新增打卡规则",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/checkInRuleForm"], resolve),
      },
      {
        path: "checkInRuleForm/edit/:id",
        name: "编辑打卡规则",
        meta: {
          menu: false,
          title: "编辑打卡规则",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/checkInRuleForm"], resolve),
      },
      {
        path: "checkInRuleForm/view/:id",
        name: "查看打卡规则",
        meta: {
          menu: false,
          title: "查看打卡规则",
        },
        component: (resolve) =>
          require(["@/views/visitManagement/checkInRuleForm"], resolve),
      },
    ],
  },
  {
    path: "/recognitionReportDetail",
    component: Layout,
    meta: {
      menu: false,
    },
    children: [
      {
        path: "view/:storeCode",
        name: "门店拍照识别详情",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/recognitionReport/DetailPage"], resolve),
      },
    ],
  },
  {
    path: "/distributionCheckForm",
    component: Layout,
    meta: {
      menu: false,
    },
    children: [
      {
        path: "add",
        name: "新增分销检查任务",
        meta: {
          menu: false,
          keepAlive: true,
        },
        component: (resolve) =>
          require(["@/views/distributionCheck/ruleForm"], resolve),
      },
      {
        path: "edit/:id",
        name: "编辑分销检查任务",
        meta: {
          menu: false,
          keepAlive: true,
        },
        component: (resolve) =>
          require(["@/views/distributionCheck/ruleForm"], resolve),
      },
      {
        path: "view/:id",
        name: "查看分销检查任务",
        meta: {
          menu: false,
          keepAlive: true,
        },
        component: (resolve) =>
          require(["@/views/distributionCheck/ruleForm"], resolve),
      },
    ],
  },
  {
    path: "/visitRuleForm",
    component: Layout,
    meta: {
      menu: false,
    },
    children: [
      {
        path: "add",
        name: "新增访店规则",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/visitManagement/visitRuleForm"], resolve),
      },
      {
        path: "edit/:id",
        name: "编辑访店规则",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/visitManagement/visitRuleForm"], resolve),
      },
      {
        path: "view/:id",
        name: "查看访店规则",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/visitManagement/visitRuleForm"], resolve),
      },
    ],
  },
  {
    path: "/executeToolForm",
    component: Layout,
    meta: {
      menu: false,
    },
    children: [
      {
        path: "add",
        name: "新建执行工具",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/executeToolForm",
          ], resolve),
      },
      {
        path: "edit/:id",
        name: "编辑执行工具",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/executeToolForm",
          ], resolve),
      },
      {
        path: "view/:id",
        name: "查看执行工具",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/executeToolForm",
          ], resolve),
      },
      {
        path: "question/add",
        name: "新增题目",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/executeTask/executeTools/questionEditor"], resolve),
      },
      {
        path: "question/edit/:index",
        name: "编辑题目",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require(["@/views/executeTask/executeTools/questionEditor"], resolve),
      },
      {
        path: "scoreItem/add",
        name: "新增评分项",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/scoreItemEditor",
          ], resolve),
      },
      {
        path: "scoreItem/edit/:groupIndex/:itemIndex",
        name: "编辑评分项",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/scoreItemEditor",
          ], resolve),
      },
      {
        path: "scoreGroup/add",
        name: "新增分组",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/scoreItemEditor",
          ], resolve),
      },
      {
        path: "scoreGroup/edit/:index",
        name: "编辑分组",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/scoreItemEditor",
          ], resolve),
      },
      {
        path: "detailField/add",
        name: "新增明细字段",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/detailFieldEditor",
          ], resolve),
      },
      {
        path: "detailField/edit/:index",
        name: "编辑明细字段",
        meta: {
          menu: false,
        },
        component: (resolve) =>
          require([
            "@/views/executeTask/executeTools/detailFieldEditor",
          ], resolve),
      },
    ],
  },
];
